<!-- 工单来源 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <Echart :options="option" style="height: 100%;"></Echart>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('工单来源'),
        url: {
          queryTicketsSourceTypeNum: "/jeecg-engineering/ticket/index/largeScreen/queryTicketsSourceTypeNum",
        },
        option: {},
        intervalId: null,
        angle: 0
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.queryTicketsSourceTypeNum,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption(data);
          }
        })
      },
      setOption(params) {
        let seriesData = [];
        params.map(item=>{
          var typeName = item.typeName;
          seriesData.push({
            value: item.num,
            name: typeName == 0?'PC':typeName == 1?this.$t('公众号'):typeName == 2?'APP':typeName == 3?this.$t('客服热线'):'',
            itemStyle: {
              color: typeName == 0?'#4634FA':typeName == 1?'#3A7BD5':typeName == 2?'#32C5FF':typeName == 3?'#50E3C2':''
            }
          })
        });
        this.option = {
          title: {
            show: false,
            text: 'Funnel'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            }
          },
          legend: {
            show: false,
            data: ['Show', 'Click', 'Visit', 'Inquiry', 'Order']
          },
          series: [
            {
              name: this.$t('工单来源'),
              type: 'funnel',
              left: '10%',
              top: 30,
              bottom: 30,
              width: '80%',
              min: 0,
              max: 100,
              minSize: '20%',
              maxSize: '100%',
              sort: 'descending',
              gap: 2,
              label: {
                show: true,
                position: 'inside',
                formatter: '{b} {c}'
              },
              labelLine: {
                length: 10,
                lineStyle: {
                  width: 1,
                  type: 'solid'
                }
              },
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 1
              },
              emphasis: {
                label: {
                  fontSize: 20
                }
              },
              data: seriesData
            }
          ]
        };
      },
      setRichText(colorList) {
        let richList = {}
        for (let i = 0; i < colorList.length; i++) {
          richList[`top${i}`] = {
            color: colorList[i].start,
            verticalAlign: 'bottom',
            padding: [5, 0, 0, 0],
            align: 'center'
          }
          richList[`topnumber${i}`] = {
            color: colorList[i].start,
            fontFamily: 'ds-digital-bold',
            verticalAlign: 'bottom',
            padding: [5, 0, 0, 0],
            fontSize: 20,
            align: 'center'
          }
          richList[`bottom${i}`] = {
            color: colorList[i].start,
            verticalAlign: 'top',
            padding: [0, 0, 5, 0],
            align: 'center'
          }
          richList[`hr${i}`] = {
            backgroundColor: colorList[i].start,
            borderRadius: 3,
            width: 3,
            height: 3,
            align: 'center',
            padding: [3, 3, 0, -12]
          }
        }
        return richList
      },
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}
  .ant-radio-button-wrapper{
    color: #fff;
    background: transparent;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
    color: #1890FF;
  }
  .progress{
    width: 35%;
    font-size: 12px;
    padding: 10px;
    .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /deep/.ant-progress-line{
      margin-bottom: 25px;
    }
    /deep/.finish .ant-progress-inner{
      background-color: #08306F;
    }
    /deep/.notfinish .ant-progress-inner{
      background-color: #20515B;
    }
    /deep/.timeout .ant-progress-inner{
      background-color: #5B5B34;
    }
  }
</style>